import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import { useSettings } from "@/context/SettingsContext";

export default function CGV() {
  const { settings } = useSettings();
  const company = settings?.company_name || "DAS SIMAO AUTO";
  const manager = settings?.manager_name || "Arnaud Simao";
  const email = settings?.email || "contact.dassimaoauto@gmail.com";

  return (
    <div className="min-h-screen bg-[#050505]" data-testid="cgv-page">
      <SEO title="Conditions générales de vente" description="Conditions générales de vente et de service de DAS SIMAO AUTO." />
      <Header />
      <article className="pt-32 pb-20 max-w-3xl mx-auto px-6 lg:px-10 prose-legal">
        <div className="text-xs tracking-[0.5em] gold uppercase">Légal</div>
        <h1 className="mt-3 font-serif text-white text-5xl leading-tight">
          Conditions générales de vente
        </h1>
        <p className="text-gray-500 text-sm mt-2">
          En vigueur au {new Date().toLocaleDateString("fr-FR")}
        </p>

        <div className="mt-10 space-y-8 text-gray-300 leading-relaxed">
          <Section title="1. Objet">
            <p>
              Les présentes conditions générales de vente (CGV) régissent
              l'ensemble des prestations proposées par {company} :
              convoyage de véhicules, transport de passagers (VTC) sous forme
              de trajet ponctuel ou de mise à disposition. Toute réservation
              vaut acceptation pleine et entière des présentes CGV.
            </p>
          </Section>

          <Section title="2. Réservation et validation">
            <p>
              Toute réservation est effectuée en ligne via le site
              dassimaoauto.fr, accompagnée du paiement de l'acompte ou du
              montant total selon la prestation choisie. Chaque réservation
              fait l'objet d'une <b>validation manuelle</b> par le gérant
              avant confirmation définitive. {company} se réserve le droit
              de refuser une réservation ; dans ce cas, le remboursement
              intégral est déclenché automatiquement.
            </p>
          </Section>

          <Section title="3. Tarifs">
            <p>
              <b>Convoyage :</b> 1,30 €/km de 0 à 100 km · 1,10 €/km de
              101 à 300 km · 1,00 €/km au-delà de 300 km. Un acompte de
              30% est prélevé à la réservation.
            </p>
            <p>
              <b>Trajet VTC :</b> 20 € de prise en charge + tarif au
              kilomètre (identique au convoyage). Majoration de 20% le
              dimanche et les jours fériés, majoration nuit 22h-6h.
              Paiement à 100% à la réservation.
            </p>
            <p>
              <b>Mise à disposition VTC :</b> 45 €/h en journée · 55 €/h de
              nuit (22h-6h). Minimum 2 heures. Majoration de 20% le
              dimanche et les jours fériés. Acompte de 30% à la réservation,
              solde en fin de prestation.
            </p>
            <p>
              Les péages, parkings et prestations supplémentaires
              éventuels ne sont pas inclus dans le tarif de base et
              peuvent être ajoutés au solde final.
            </p>
          </Section>

          <Section title="4. Paiement">
            <p>
              Le paiement s'effectue en ligne via la plateforme sécurisée
              Stripe. {company} n'a jamais accès aux données bancaires
              du client. Aucun paiement en espèces ou par chèque n'est
              accepté pour la partie en ligne.
            </p>
          </Section>

          <Section title="5. Annulation et remboursement">
            <p>
              En cas d'annulation par le client jusqu'à 48 heures avant la
              prestation : remboursement intégral de l'acompte. Entre 48
              heures et 24 heures avant : l'acompte reste dû. Moins de 24
              heures avant : facturation intégrale.
            </p>
            <p>
              En cas d'annulation par {company} après paiement : remboursement
              automatique et intégral via Stripe. Les délais bancaires
              (3 à 10 jours ouvrés) sont indépendants de notre volonté.
            </p>
          </Section>

          <Section title="6. Responsabilité et assurance">
            <p>
              {company} est titulaire d'une assurance professionnelle
              couvrant l'ensemble des véhicules convoyés du départ à la
              livraison, ainsi qu'une responsabilité civile professionnelle
              pour les prestations VTC. Une inspection du véhicule est
              réalisée au départ et à l'arrivée.
            </p>
          </Section>

          <Section title="7. Données personnelles">
            <p>
              Les données collectées lors de la réservation (nom, email,
              téléphone, adresses) sont strictement utilisées pour la
              gestion de la prestation. Voir notre{" "}
              <a href="/confidentialite" className="gold underline">
                politique de confidentialité
              </a>{" "}
              pour plus de détails et l'exercice de vos droits RGPD.
            </p>
          </Section>

          <Section title="8. Litiges">
            <p>
              À défaut de résolution amiable, tout litige relatif aux
              présentes CGV sera soumis aux juridictions françaises
              compétentes selon le droit commun.
            </p>
          </Section>

          <Section title="9. Contact">
            <p>
              Pour toute question relative aux présentes CGV, contactez :{" "}
              <a href={`mailto:${email}`} className="gold underline">
                {email}
              </a>{" "}
              — Gérant : {manager}.
            </p>
          </Section>
        </div>
      </article>
      <Footer />
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-serif text-2xl text-white">{title}</h2>
      <div className="mt-3 space-y-3 text-[15px]">{children}</div>
    </section>
  );
}
